import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, UnidadeRecursoSubstituto } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class UnidadeRecursoSubstitutoService extends BaseResourceService<UnidadeRecursoSubstituto> {

  constructor(
    protected injector: Injector
  ) {
    super(`unidade-recurso-substitutos`, injector);
  }

}
